import React from 'react'
import { RouterProvider } from 'react-router'
import { GoogleOAuthProvider } from '@react-oauth/google'

import ErrorBoundary from './components/Common/ErrorBoundary'
import StoreProvider from './components/StoreProvider'
import { IntercomProvider } from './components/IntercomProvider'
import { CookieBanner } from './components/Consent/CookieBanner'
import { CookiePreferences } from './components/Consent/CookiePreferences'
import router from './router'

const App: React.FC = () => (
  <ErrorBoundary>
    <GoogleOAuthProvider clientId={process.env.VITE_GOOGLE_CLIENT_ID!}>
      <StoreProvider>
        <IntercomProvider />
        <RouterProvider router={router} />
        <CookieBanner />
        <CookiePreferences />
      </StoreProvider>
    </GoogleOAuthProvider>
  </ErrorBoundary>
)
App.displayName = 'App'
export default App
